import React from 'react'
import {
  ParagraphSecondary,
  ButtonPrimary,
  TitleSecondary,
  SpacerVertical
} from '@klarna/bubble-ui'
import { Message } from 'mage-i18n'
import { useHelpContext } from '../../hooks'

function NotAvailableOnMobile () {
  const { navigation } = useHelpContext()
  return (
    <div>
      <TitleSecondary>
        <Message path='help-tool.notAvailableMobile.title' fallback='Not Available' />
      </TitleSecondary>
      <ParagraphSecondary>
        <Message
          path='help-tool.notAvailableMobile.paragraph'
          fallback='This content is not available on your device.'
        />
      </ParagraphSecondary>
      <SpacerVertical medium />
      <ButtonPrimary onClick={() => navigation.pop()}>
        <Message path='help-tool.notAvailableMobile.buttonBack' fallback='Back' />
      </ButtonPrimary>
    </div>
  )
}

export default NotAvailableOnMobile
